<template>
  <div class="activity">
    <img :src="url" alt="">
  </div>
</template>

<script>

import {getDownloadBanner} from "../../api"

export default {
  name: 'Activity',
  mounted() {

  },
    data(){
    return {
      url:""
    }
  },
  created(){
    getDownloadBanner({"code":"Ad-sjgf-newUser-activityDescription"}).then(res=>this.url = res.data[0].url)
  },
}
</script>

<style lang="scss" scoped>
.activity{
  font-size: 0;
  img{
    width: 100%;
  }
}

</style>
